import {
  CircularProgressProps,
  CircularProgress as Progress,
} from "@mui/material";
import React from "react";

interface ICircularProgressProps extends CircularProgressProps {
  size?: "sm" | "md" | "lg";
}

const SIZES = {
  sm: 12,
  md: 18,
  lg: 24,
};

export const CircularProgress: React.FunctionComponent<
  ICircularProgressProps
> = ({ size = "sm", ...props }) => {
  return <Progress size={SIZES[size]} {...props} />;
};

export default CircularProgress;
